module.exports = __webpack_public_path__ + "static/media/work-img2.d7f1fafa.jpg";